
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"M1.825 16.117h5.912v14.226H1.825zM38.952 16.121h5.37v14.227h-5.37z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M29.184 12.558s2.068-1.08 5.01 0c2.943 1.082 4.224 4.517 4.224 4.517h2.235M14.192 32.682c-1.353.035-2.05-2.97-1.876-3.367.174-.398 2.262-1.122 6.722-3.867s5.575-3.551 4.886-8.697c0 0 3.373 4.255 4.884 5.146s3.12.356 3.453-1.104c.333-1.461-1.449-4.072-4.147-6.875-2.697-2.802-4.562-3.646-8.393-2.223-3.378 1.254-7.405 4.082-8.47 5.5H8.95m5.243 15.487c1.353-.036 6.632-3.367 6.632-3.367m-6.632 3.366s.22 3.356 2.446 3.022 6.044-3.022 6.044-3.022m-5.423 2.87s.375 2.532 2.462 2.153 6.058-2.612 6.058-2.612m3.482-5.87c0-.388-.714-2.114 1.427-2.712 2.14-.597 4.364 4.458 3.898 6.042-.467 1.584-3.402.966-3.402.966m.91-6.6s-.57-2.188 1.27-2.676c3.218-.854 4.684 5.19 4.403 6.113-.475 1.555-3.125 1.367-3.125 1.367m3.776-4.818h2.235M13.12 28.56c-.238-.307-1.709-.75-1.868-1.945H8.95m17.382 5.637c0 1.712.29 2.915 1.783 3.45 1.693.609 2.717-.681 2.79-2.62.067-1.753-1.002-3.972-2.612-3.86-1.323.093-1.962.926-1.962 3.03Z"}}),_c('path',{attrs:{"stroke":"#234652","d":"M3.956 15.08h5v13.795h-5zm36.606 0h5v13.795h-5z"}})])
          )
        }
      }
    